module.exports = __webpack_public_path__ + "img/ke.ke785c24b.svg";